import Vue from 'vue'
import Vuex from 'vuex'
import option from './modules/option'
import job from './modules/job'
import client from './modules/client'
import quote from './modules/quote'
import invoice from './modules/invoice'
import order from './modules/order'
import template from './modules/email-template'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    option,
    job,
    client,
    quote,
    invoice,
    order,
    template
  }
});
